module.exports = __webpack_public_path__ + "static/img/cdm-logo.7ad3e2c8.svg";